import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  patchMusicLink,
} from 'redux/music-links/actions';

import { Checkbox } from 'semantic-ui-react';

const MusicLinkPublishedCheckbox = ({
  musicLinkId,
  isPublished,
  patchMusicLink,
}) => {

  const checkboxChange = (_e, { checked }) => {
    patchMusicLink(musicLinkId, { is_published: checked });
  };

  return (
    <Checkbox
      className="music-link-published-checkbox__component"
      toggle
      checked={isPublished && Boolean(isPublished)}
      onChange={checkboxChange}
    />
  );
};

MusicLinkPublishedCheckbox.propTypes = {
  musicLinkId: PropTypes.number,
  isPublished: PropTypes.bool,
  patchMusicLink: PropTypes.func,
};
MusicLinkPublishedCheckbox.defaultProps = {
  musicLinkId: null,
  isPublished: null,
  patchMusicLink: null,
};

export default connect(
  null,
  {
    patchMusicLink,
  },
)(MusicLinkPublishedCheckbox);
